import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MarketCompany } from 'src/app/Model/MarketCompany.Model';
import { GenericService } from 'src/app/Services/generic.service';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { Global } from 'src/app/modules/shared/global';
@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css'],
  standalone: false
})

export class DeleteModalComponent implements OnInit {
  @Output() onConfirmEmit = new EventEmitter<MarketCompany>();
  @Output() onSelectEmit = new EventEmitter<string>();

  @Input('title') public title: string | string[] = '';
  @Input('idModal') public idmodal: string | string[] = '';
  id = localStorage.getItem("Vista_userId");
  public marketcompaniesToDelete: MarketCompany[];
  public selectedMarketCoToDelete: MarketCompany;
  public parameters: any;

  constructor(public genericService: GenericService, public auth: AuthenticationService) {

  }
  selectedFilterMarket = "0";

  ngOnInit() {
    this.selectedFilterMarket = localStorage.getItem("Vista_selectedFilterMarket").toString();
    let filtermco = this.selectedFilterMarket == "0" ? "0" : this.selectedFilterMarket;
    this.getListMarketCompanyToDelete(filtermco)
  }

  SelectedMarketCoToDelete(event: any) {
    this.onSelectEmit.emit(event)
  }

  DeleteParam() {
    this.onConfirmEmit.emit(this.selectedMarketCoToDelete)
  }

  getListMarketCompanyToDelete(filtermco): void {
    let _url = Global.BASE_API_MarketCompanies_Base.concat(
      "GetAll?id=" + this.id + "&selectedmco=" + filtermco
    );
    this.genericService
      .get(_url)
      .subscribe((data: any) => {
        this.selectedMarketCoToDelete = data.json;
        if (!!this.marketcompaniesToDelete)
          this.selectedMarketCoToDelete =
            this.marketcompaniesToDelete[0];
        if (filtermco == "0") {
          this.marketcompaniesToDelete =
            this.genericService.ListMarketCompany;
          this.selectedMarketCoToDelete =
            this.marketcompaniesToDelete[0];
        } else {
          this.marketcompaniesToDelete =
            this.genericService.ListMarketCompany.filter(
              (x) => x.marketCompanyId == filtermco
            );
          this.selectedMarketCoToDelete =
            this.marketcompaniesToDelete[0];
        }
      });
  }

}
